import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {CompetitionHighlightsPageConfig} from "./competition-highlights-page.config";
import {CompetitionHighlightsPageState} from "./models/competition-highlights-page.state";

export class CompetitionHighlightsPageStore extends BaseMobxStore {
  static injectables = [CompetitionHighlightsPageConfig, CompetitionHighlightsPageState];

  state: CompetitionHighlightsPageState;
}
